import { accrualPolicySchema, schemes, zSchema } from "@zeal/common";

export const updateAccrualPolicyRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  id: schemes.mongoOrUuid(),
  policy_name: schemes.nonEmptyString("Policy name is required."),
});

export type TUpdateAccrualPolicyRequestSchema = zSchema.infer<
  typeof updateAccrualPolicyRequestSchema
>;

export const updateAccrualPolicyResponseSchema = accrualPolicySchema;

export type TUpdateAccrualPolicyResponseSchema = zSchema.infer<
  typeof updateAccrualPolicyResponseSchema
>;
